import { app } from '../../app';
import { Controller } from './sp-addition-source.controller';

app.component('spAdditionSource', {
    bindings: {
        additionSource: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-addition-source.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-addition-source/sp-addition-source.component.js